import React, { useEffect } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import * as apiMethods from "../res/apiMethods.js";
import "date-fns";
import IconButton from "@mui/material/IconButton";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import LockResetIcon from "@mui/icons-material/LockReset";
import { useFormik } from "formik";
import { createTheme } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@mui/styles";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Button from "@mui/material/Button";
import { DataGrid } from "@mui/x-data-grid";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import * as yup from "yup";
import Swal from "sweetalert2";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Sidebar from "../components/Sidebar";
import AccessDenied from "./accessDenied.jsx";

const Users = () => {
  const [props, setProps] = React.useState({
    usersData: [],
    createDialog: false,
    update: false,
    userId: "",
    isAdmin: null, 
  });
  const [passwordDialog, setPasswordDialog] = React.useState({
    open: false,
    usrId: "",
    username: "",
  });
  const [passwordForm, setPasswordForm] = React.useState({
    password: "",
    confirmPassword: "",
  });

  const isComplemento360 = React.useMemo(() => {
    try {
      const username = window.sessionStorage.getItem("username");
      const token = window.sessionStorage.getItem("localToken");
      if (!username || !token) return false;
      if (username !== "complemento360") return false;
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.roleId === 1;
    } catch {
      return window.sessionStorage.getItem("username") === "complemento360";
    }
  }, [props.isAdmin]);

  const validationSchema = yup.object().shape({
    username: yup.string().required("El nombre de usuario es requerido"),
    password: yup.string().required("La contraseña es requerida"),
    roleId: yup.string().required("El rol es requerido"),
  });

  const formik = useFormik({
    validationSchema: validationSchema,
    onSubmit: (values) => {
      
    },
    initialValues: {
      username: "",
      password: "",
      roleId: "2",
    },
  });

  const setState = (value) => {
    setProps((prevState) => ({ ...prevState, ...value }));
  };

  const loadUsers = async () => {
    try {
      let actUsrToken = window.sessionStorage.getItem("localToken");
      let usersResponse = await axios.get(apiMethods.GET_USUARIO_ALL, {
        headers: { Authorization: actUsrToken }
      });
      
      if (usersResponse.data.code === 0 && usersResponse.data.clients) {
        setState({ usersData: usersResponse.data.clients });
        return true;
      } else {
        setState({ usersData: [] });
        return false;
      }
    } catch (error) {
      console.error("Error al cargar usuarios:", error);
      setState({ usersData: [] });
      
      if (error.response?.status === 403) {
        toast.error("No tienes permisos para acceder a esta sección");
      }
      
      return false; 
    }
  };

  useEffect(() => {
    (async () => {
      document.title = "Usuarios";
      const isAllowed = await loadUsers();
      
      if (isAllowed) {
        setState({ isAdmin: true });
      } else {
        setState({ isAdmin: false });
      }
    })();
  }, []);

  const openPasswordDialog = (row) => {
    setPasswordDialog({ open: true, usrId: row.usrId, username: row.username });
    setPasswordForm({ password: "", confirmPassword: "" });
  };

  const closePasswordDialog = () => {
    setPasswordDialog({ open: false, usrId: "", username: "" });
    setPasswordForm({ password: "", confirmPassword: "" });
  };

  const handlePasswordChange = async (e) => {
    if (e) e.preventDefault();
    const { password, confirmPassword } = passwordForm;
    if (!password || !confirmPassword) {
      toast.error("Por favor complete ambos campos de contraseña");
      return;
    }
    if (password.length < 8) {
      toast.error("La contraseña debe tener al menos 8 caracteres");
      return;
    }
    if (password !== confirmPassword) {
      toast.error("Las contraseñas no coinciden");
      return;
    }
    try {
      const actUsrToken = window.sessionStorage.getItem("localToken");
      const response = await axios.patch(
        apiMethods.PATCH_USUARIO_PASSWORD + passwordDialog.usrId,
        { password },
        { headers: { Authorization: actUsrToken } }
      );
      if (response.data.code === 0) {
        toast.success(`Contraseña de "${passwordDialog.username}" actualizada con éxito`);
        closePasswordDialog();
      } else {
        toast.error(response.data.message || "Error al actualizar la contraseña");
      }
    } catch (error) {
      const msg = error.response?.data?.message || error.message || "Error al actualizar la contraseña";
      if (error.response?.status === 403) {
        toast.error("Acceso denegado. Solo complemento360 puede cambiar contraseñas.");
      } else {
        toast.error(msg);
      }
    }
  };

  const renderDetailsButton = (params) => {
    return (
      <strong>
        <IconButton
          variant="contained"
          size="small"
          style={{ marginLeft: 16 }}
          title="Ver / editar usuario"
          onClick={() => {
            setState({ update: true, userId: params.row.usrId });
            openCreateDialog({
              username: params.row.username,
              roleId: String(params.row.roleId),
            });
          }}>
          <VisibilityIcon />
        </IconButton>
        {isComplemento360 && (
          <IconButton
            variant="contained"
            size="small"
            style={{ marginLeft: 8 }}
            title={`Cambiar contraseña de ${params.row.username}`}
            onClick={() => openPasswordDialog(params.row)}>
            <LockResetIcon />
          </IconButton>
        )}
        <IconButton
          variant="contained"
          size="small"
          style={{ marginLeft: 8 }}
          title="Eliminar usuario"
          onClick={() => {
            Swal.fire({
              title: "¿Estás seguro?",
              text: "¿Deseas eliminar este usuario?",
              icon: "warning",
              showCancelButton: true,
              confirmButtonColor: "#3085d6",
              cancelButtonColor: "#d33",
              confirmButtonText: "Si",
              cancelButtonText: "No",
              allowOutsideClick: false,
            }).then(async (result) => {
              if (result.isConfirmed) {
                let actUsrToken = window.sessionStorage.getItem("localToken");
                let deleteResponse = await axios.delete(
                  apiMethods.DELETE_USUARIO_ID + params.row.usrId,
                  { headers: { Authorization: actUsrToken } }
                );
                if (deleteResponse.data.code == 0) {
                  toast.success("Usuario eliminado correctamente");
                  loadUsers();
                } else {
                  toast.error(deleteResponse.data.message || "Error al eliminar usuario");
                }
              }
            });
          }}>
          <DeleteIcon />
        </IconButton>
      </strong>
    );
  };

  const roles = ["Administrador", "Usuario"];
  const creditsColumns = [
    { field: "username", headerName: "Usuario", width: 300 },
    { 
      field: "roleId", 
      headerName: "Rol", 
      width: 300,
      renderCell: (params) => {
        if (!params?.row?.roleId || !roles?.length) {
          return '-';
        }
        
        const roleIndex = params.row.roleId - 1;
        const roleName = roles[roleIndex] || 'Rol desconocido';
        
        return roleName;
      }
    },
    {
      field: "action",
      headerName: "Acción",
      width: isComplemento360 ? 280 : 200,
      renderCell: renderDetailsButton,
    },
  ];

  const createUser = async (e) => {
  e.preventDefault();
  let valid = true;
  for (let val in formik.values) {
    if (formik.values[val] === "") {
      valid = false;
      break;
    }
  }
  if (valid) {
    let actUsrToken = window.sessionStorage.getItem("localToken");
    
    // Crear objeto limpio con solo los valores necesarios
    const userData = {
      username: formik.values.username,
      password: formik.values.password,
      roleId: formik.values.roleId
    };
    
    let signUpResponse = await axios.post(
      apiMethods.CREATE_USUARIO, 
      userData,  // ← Cambiar esta línea
      { headers: { Authorization: actUsrToken } }
    );
    
    if (signUpResponse.data.code == 0) {
      toast.success("Usuario creado con éxito");
      closeCreateDialog();
      loadUsers();
    } else {
      toast.error(signUpResponse.data.message || "Error al crear el usuario");
    }
  }
};

  const updateUser = async (e) => {
    e.preventDefault();
    let valid = true;
    let userData = { ...formik.values };
    delete userData.password;
    for (let val in userData) {
      if (userData[val] === "") {
        valid = false;
        break;
      }
    }
    if (valid) {
      // El backend ahora maneja la validación de username existente
      let actUsrToken = window.sessionStorage.getItem("localToken");
      let patchResponse = await axios.patch(
        apiMethods.PATCH_USUARIO_ID + props.userId,
        userData,
        { headers: { Authorization: actUsrToken } }
      );
      
      if (patchResponse.data.code == 0) {
        toast.success("Usuario actualizado con éxito");
        closeCreateDialog();
        loadUsers();
      } else {
        toast.error(patchResponse.data.message || "Error al actualizar el usuario");
      }
    } else {
      toast.error("Por favor complete todos los campos");
    }
  };

  const defaultTheme = createTheme();

  const useStyles = makeStyles({
    formControl: {
      margin: defaultTheme.spacing(1),
      minWidth: 120,
    },
  });

  const onError = (e) => {
    e.preventDefault();
    for (let error in formik.errors) {
      toast.error(formik.errors[error]);
    }
  };

  const classes = useStyles();

  const openCreateDialog = (formData) => {
    if (formData) {
      for (let val in formData) {
        formik.setFieldValue(val, formData[val]);
      }
    }
    setState({ createDialog: true });
  };

  const closeCreateDialog = () => {
    formik.resetForm();
    setState({ createDialog: false, update: false });
  };
  
    if (props.isAdmin === false) {
    return <AccessDenied />;
  }

  if (props.isAdmin === null) {
    return (
      <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', height: '80vh'}}>
        <p>Cargando...</p>
      </div>
    );
  }

  return window.sessionStorage.getItem("localToken") ? (
    <React.Fragment>
      <ToastContainer />
      <div style={{ display: "grid", gridTemplateColumns: "15% 85%" }}>
              <Sidebar />
      <div className="card" style={{ padding: "2rem" }}>
        <div
          style={{
            fontSize: "15pt",
            fontWeight: "500",
            marginBottom: "2rem",
            marginTop: "1rem",
            marginLeft: "1rem",
          }}>
          Usuarios
        </div>
        <div style={{ height: 630, width: "100%", marginBottom: "1rem" }}>
          {props.usersData.length > 0 && (
            <DataGrid
              getRowId={(row) => row._id}
              rows={props.usersData || []} 
              columns={creditsColumns}
              pageSize={10}
              rowsPerPageOptions={[10]}
              disableSelectionOnClick
            />
          )}
        </div>
        <Button
          onClick={() => openCreateDialog()} 
          variant="contained"
          sx={{
              backgroundColor: 'rgb(238, 238, 238)',
              color: "black",
              '&:hover': { backgroundColor: '#e92128', fontWeight: 'bold', color: 'white' }
          }}
          style={{ width: "40%",marginLeft:"30%" }}
          type="submit">
          Crear Usuario
        </Button>
      </div>
      </div>
      <Dialog
        open={props.createDialog}
        onClose={closeCreateDialog}
        fullWidth={true}
        maxWidth="md">
        <DialogTitle id="alert-dialog-title">
          {props.update ? "Actualizar usuario" : "Crear usuario"}
        </DialogTitle>
        <DialogContent>
          <form
            onSubmit={(e) => {
              formik.isValid ? createUser(e) : onError(e);
            }}>
            <div style={{ display: "grid", gridTemplateColumns: "auto auto" }}>
              <div className="create-credit-input-row">
                <TextField
                  required
                  className="create-credit-input"
                  label="Nombre de usuario"
                  id="username"
                  value={formik.values.username}
                  onChange={formik.handleChange}
                  margin="normal" 
                />
              </div>{" "}
              {!props.update && (
                <div className="create-credit-input-row">
                  <TextField
                    required
                    className="create-credit-input"
                    label="Contraseña"
                    id="password"
                    margin="normal" 
                    type="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                  />
                </div>
              )}
              <div className="create-credit-input-row">
                <FormControl className={classes.formControl}>
                  <InputLabel>Rol</InputLabel>
                  <Select
                    required
                    label="Rol"
                    name="roleId"
                    id="roleId"
                    style={{ textAlign: "left" }}
                    value={formik.values.roleId}
                    onChange={formik.handleChange}>
                    <MenuItem value="1">Administrador</MenuItem>
                    <MenuItem value="2">Usuario</MenuItem>
                  </Select>
                </FormControl>
              </div>
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={props.update ? updateUser : createUser}>
          {props.update ? "Actualizar" : "Crear"}
          </Button>
          <Button onClick={closeCreateDialog}>Cerrar</Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={passwordDialog.open}
        onClose={closePasswordDialog}
        fullWidth={true}
        maxWidth="xs">
        <DialogTitle>Editar contraseña — {passwordDialog.username}</DialogTitle>
        <DialogContent>
          <form onSubmit={handlePasswordChange}>
            <div style={{ display: "flex", flexDirection: "column", gap: "1rem", marginTop: "0.5rem" }}>
              <TextField
                required
                label="Nueva contraseña"
                type="password"
                value={passwordForm.password}
                onChange={(e) => setPasswordForm((p) => ({ ...p, password: e.target.value }))}
                margin="normal"
                helperText="Mínimo 8 caracteres"
                fullWidth
              />
              <TextField
                required
                label="Confirmar contraseña"
                type="password"
                value={passwordForm.confirmPassword}
                onChange={(e) => setPasswordForm((p) => ({ ...p, confirmPassword: e.target.value }))}
                margin="normal"
                fullWidth
              />
            </div>
          </form>
        </DialogContent>
        <DialogActions>
          <Button onClick={closePasswordDialog}>Cancelar</Button>
          <Button onClick={handlePasswordChange} variant="contained">Guardar</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  ) : (
    <AccessDenied />
  );
};

export default Users;